import { ProductDetailsWithVariant } from '@models';
export interface ProductVariance {
  id: string;
  productId: number;
  name: string;
  description: string;
  controlType: string;
  isRequired: boolean;
  enabled: boolean;
  groupName: string | null;
  order: number;
  options: ProductVarianceOption[];
}

export interface ProductVarianceOption {
  id: string;
  productVarianceId: string;
  displayValue: string;
  value: string;
  imageUrl?: string | null;
  colorCode?: string | null;
  additionalPrice: number;
  enabled: boolean;
  isDefault: boolean;
  order: number;
}

export interface VariantGrouping {
  id: string;
  name: string;
  partNumber: string;
  parentProductId: number;
  finalPrice: number;
  additionalPrice: number;
  isEnabled: boolean;
  options: VariantGroupingOption[];
  categoryId: number;
}
export interface VariantGroupingOption {
  id: string;
  productVariantGroupingId: string;
  productVarianceOptionId: string;
  variance: VariantGroupVariance;
  option: ProductVarianceOption;
}
export interface VariantGroupVariance {
  id: string;
  productId: number;
  name: string;
  description: string;
  controlType: string;
  isRequired: boolean;
  enabled: boolean;
  groupName: string | null;
  order: number;
  options: ProductVarianceOption[];
}

export interface RelatedProduct {
  productId: number;
  name: string;
  relatedParentId: number;
  brandName: string;
  price: number;
  discountedPrice: number | null;
  imageUrl: string;
  isPromo: boolean;
  isTruckShip: boolean;
  images: Array<string[]>;
  hasVariants: boolean;
}
export interface SimilarProduct extends Omit<ProductDetailsWithVariant, 'similarProducts'> {
  similarProducts: never[]; // Prevent nesting
}
